<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        {{ !userIsAdmin || (partnerFilters && partnerFilters.in_network) ? "Your" : "Out of Network" }} Pros
      </div>
    </template>
    <ProList @drill-down="clickPro" />
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import ProList from './ProList'
import { mapGetters } from 'vuex'

export default {
  name: 'ProsListView',

  components: {
    ContentPage,
    ProList,
  },

  computed: {
    ...mapGetters('auth', ['userIsAdmin']),
    ...mapGetters('filters', ['partnerFilters']),
  },

  methods: {
    clickPro(pro) { 
      this.$router.push({ name: 'pros/show', params: { pro_id: pro.pro_id } })
    },

    titleClick() {
    }
  },
}
</script>